<template>
    <div>
        <b-toast
        id="toast-check-modal-upload-file"
        variant="none"
        no-close-button
        toaster="b-toaster-top-center"
        >
        <img
          src="@/assets/img/ico-check.png"
          style="margin-right: 10px; margin-top: -2px"
        />
        {{ message }}
        </b-toast> 
        <b-toast
        id="toast-equis-modal-upload-file"
        variant="none"
        no-close-button
        toaster="b-toaster-top-center"
        >
        <img
          src="@/assets/img/ico-equis.png"
          style="margin-right: 10px; margin-top: -2px"
        />
        {{ message }}
        </b-toast>
        <b-breadcrumb>
            <b-breadcrumb-item @click="redireccionar">{{$t('evaluacion.label')}}</b-breadcrumb-item>
            <b-breadcrumb-item active>{{titleAssignment_evaluation}}</b-breadcrumb-item>
        </b-breadcrumb>
        <div class="card">
            <div class="card-body">
                <div class="back-step mt-0"  @click="redireccionar">
                  <icon name="arrow-left"/>
                  <!-- <img class="svg" src="@/assets/icons/icon-arrow-left.svg"> -->
                  {{$t('planesYPrecios.regresar')}}
                </div>
                <b-row>
                    <b-col class="d-flex align-items-center justify-content-end" style="border-right: 1px solid #b7b8bd;">
                        <h4 class="sub-title d-flex mb-0" style="padding-right: 20px;">
                            <span>{{ flagEvaluation ?  $t('evaluacion.sub-title-11') : $t('evaluacion.sub-title-12')}} :</span>
                            <p class="mb-0" style="font-weight: 400;margin-left: 6px;">
                              {{module ? module.id != '-' ? module.strModule : $t('assignments-evaluations.table-th.module') + ' -' : '-'}}
                            </p>
                        </h4>
                    </b-col>
                    <b-col> 
                        <div class="sub-title-img name" style="padding-left: 18px;">
                            <img src="@/assets/img/progress-small.png">
                            <div>
                                <span class="link bold">{{$t('evaluacion.sub-title-5')}}</span>
                                <p>{{course ? course.split('-')[2] : '-'}}</p>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <div>
                    <h6 class="bold" style="font-size: 15px;">{{titleAssignment_evaluation}}:</h6>
                    <template>
                    <!-- :accept="'image/*,.zip'" -->
                        <VueFileAgent
                            
                            ref="vueFileAgent"
                            :multiple="true"
                            :deletable="true"
                            :meta="true"
                            :accept="SUPPORTEDFILES.join(',')"
                            :maxSize="'10MB'"
                            :maxFiles="14"
                            :helpText="$t('evaluacion.fileInput.1')"
                            :errorText="{
                              type: $t('evaluations.file-upload.file-error-type'),
                              size: $t('evaluations.file-upload.file-error-size'),
                            }"
                            @select="filesSelected($event)"
                            @beforedelete="onBeforeDelete($event)"
                            @delete="fileDeleted($event)"
                            v-model="fileRecords"
                        >
                        <template v-slot:after-inner>
                            <p style="line-height: 1.3;margin-bottom: 4px;" :class="fileRecordsForUpload.length >= 1 ? 'mt-3': ''">
                                {{$t('evaluacion.fileInput.1')}}
                                <br>
                                {{$t('evaluacion.fileInput.2')}}
                            </p>
                            <b-button class="btn btn-primary">
                                {{$t('evaluacion.fileInput.button')}}
                            </b-button>
                        </template >
                        <template v-slot:after-outer>
                            <p class="footer-file-agent">
                                {{ fileRecords.length }} / 5
                            </p>
                        </template >
                        </VueFileAgent>
                    </template>
                    <h6 class="bold" style="font-size: 15px;">{{$t('evaluacion.sub-title-7')}}</h6>
                    <b-form-group>
                        <b-form-textarea
                            id="textarea-small"
                            rows="4"
                            :placeholder="$t('evaluacion.text.11')"
                            v-model="comment"
                            no-resize
                        ></b-form-textarea>
                    </b-form-group>
                </div>
                <div class="d-flex align-items-center justify-content-center">
                
                    <b-button  :disabled="disabledButton()" class="btn btn-primary mr-3" @click="$bvModal.show('modalConfirmUpload')">
                          <span style="color:#FFFFFF;font-weight: bold;">{{parseInt(id) != 0 ? $t('evaluacion.buttons.3') : $t('evaluacion.buttons.1')}}</span>                          
                    </b-button>
                    <b-button  variant="btn btn-danger  ml-3" @click="cancelButton()">
                        {{$t('evaluacion.buttons.2')}}
                    </b-button>
                </div>
                <b-modal 
                  v-model="modalConfirmUpload"
                  id="modalConfirmUpload" 
                  :hide-footer="true"
                  :hide-header="true"
                  centered
                >
                  <h6 class="sub-title"><span>{{$t('evaluacion.modals.title-1',{ HOMEWORKEVALUATION: flagEvaluation ? $t('evaluacion.sub-title-4') : $t('evaluacion.sub-title-10')})}}</span></h6>
                    <div class="d-block text-right">
                      <button class="btn btn-danger mr-3" style="display:initial" @click="$bvModal.hide('modalConfirmUpload')">{{$t('modals.modalConfirm.button-cancel')}}</button>                      
                      <b-button class="btn btn-primary mr-3" @click="handleSaveFiles">
                          <span v-if="!showSpinnerSave" style="color:#FFFFFF;font-weight: bold;"> {{$t('modals.modalConfirm.button')}}</span>
                          <b-spinner style="width: 1rem !important; height: 1rem !important; color:#FFFFFF;" v-else label="Spinning">                            
                          </b-spinner>
                    </b-button>
                    </div>
                </b-modal>
                <b-modal 
                  v-model="modalConfirmCancel"
                  id="modalConfirmCancel" 
                  :hide-footer="true"
                  :hide-header="true"  
                >
                  <h6 class="sub-title"><span>{{$t('evaluacion.modals.title-2',{ HOMEWORKEVALUATION: flagEvaluation ? $t('evaluacion.sub-title-4') : $t('evaluacion.sub-title-10')})}}</span></h6>                    
                    <div class="d-block text-right">
                      <button class="btn btn-danger mr-3" style="display:initial" @click="$bvModal.hide('modalConfirmCancel')">{{$t('modals.modalConfirm.button-cancel')}}</button>
                      <b-button  variant="btn btn-primary  ml-3" @click="closeModalComfirmCancel">
                        {{$t('modals.modalConfirm.button')}}
                    </b-button>
                    </div>
                </b-modal>
            </div>
        </div>
        
        
    </div>
    
</template>
<script>
import Vue from 'vue';
import VueFileAgent from 'vue-file-agent';
import VueFileAgentStyles from 'vue-file-agent/dist/vue-file-agent.css';
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
import * as tools from '@/assets/js/tools.js';
import { required, requiredIf } from 'vuelidate/lib/validators'
import { validationMessage } from "vuelidate-messages";
import axios from 'axios';
import  {SUPPORTEDFILES_HE}  from '@/assets/js/appConstants';

const formMessages = {
	  required : function(){
      return  this.$t('reusables.obligatoryField')},
}


Vue.use(VueFileAgent);
  export default {
    data() {
      return {
        message:'',
        showSpinnerSave:false,
        comment : "",
        commnetInit : "",
        fileRecords: [],
        fileRecordInit: [],
        uploadUrl: 'https://www.mocky.io/v2/5d4fb20b3000005c111099e3',
        uploadHeaders: { 'X-Test-Header': 'vue-file-agent' },
        fileRecordsForUpload: [], // maintain an upload queue
        listFilesDeleteId : [],
        titleAssignment_evaluation: "",
        modalConfirmUpload: false,
        modalConfirmCancel: false,
        SUPPORTEDFILES: SUPPORTEDFILES_HE
      }
    },
    computed : {
      User: {
        get() {
          return this.$store.state.user;
        },
        set(value) {
          this.$store.commit('mutateUser', value);
        }
      }
    },
    validations : {
        fileRecords: {
                required
        },
        comment: {
            required
        },
        validationGroup: ['fileRecordsForUpload','comment']
    },
    props : {
      id : Number,
      flagEdited: Boolean ,
      course : String,
      flagEvaluation:Boolean,
      module : Object,
      groupPersonId: Number,
      personStudentId:Number,
      groupId: Number
    },
    created(){
      if(this.id == undefined){
        this.$router.push({name : 'teacher-class'}).catch(err => {}); 
      }else{
        this.titleAssignment_evaluation = this.flagEvaluation ? this.$t('evaluacion.text.2') : this.$t('evaluacion.text.12');
        this.getFileStudent();
      }
    },
    methods:{
      disabledButton(){
        if(this.id != 0){
           return this.commnetInit == this.comment && JSON.stringify(this.fileRecords) == JSON.stringify(this.fileRecordInit)
        }else{
           return this.commnetInit == this.comment || JSON.stringify(this.fileRecords) == JSON.stringify(this.fileRecordInit)
        }
      },
      handleSaveFiles(){
        this.showSpinnerSave = true;
        const formData = new FormData();

        let dataModel = {
          Id: this.id ,
          GroupRegisterSubjectId: this.course ? parseInt(this.course.split('-')[0]) :null,
          FlagEvaluation:this.flagEvaluation,
          PersonsStudentId:this.personStudentId,
          StudentComments:this.comment,
          Module: this.module ? this.module.id == '-' ? null : this.module.id : null ,
          UserCreated :this.User.email ,
          GroupPersonId :this.groupPersonId,
          FlagTeacher:true,
          GroupId : this.groupId
        }
  console.log(dataModel);
        formData.append("ModelStr", JSON.stringify(dataModel));
        this.fileRecordsForUpload.forEach(element => {
          formData.append("ListFiles", element.file);
        });

        this.listFilesDeleteId.forEach(element => {
          formData.append("ListFilesIds", element);
        });

        const header = {
          'Content-Type': 'multipart/form-data',
          'Authorization': 'Bearer ' + this.$store.state.authToken
        };

         axios({
            method: "POST",
            url: `${this.apiURL}/Resources/PersonsAssignmentsEvaluations/Save`,
            data: formData,
            headers: header
            })
            .then(response => {
              //console.log('response: ', response);
              this.message = this.$t('evaluations.file-upload.message-success');
              this.$bvToast.show("toast-check-modal-upload-file");
              this.showSpinnerSave =false;
              this.id = response.data.value;
              this.fileRecordsForUpload = [];
              setTimeout( ()=>{
                    this.$bvModal.hide('modalConfirmUpload');
                    //this.$router.go(-1);
              }, 500);
             
            })
            .catch(function (error) {
                console.log('error: ', error);
               
                this.message = this.$t('evaluations.file-upload.message-error');
                this.$bvToast.show("toast-equis-modal-upload-file");
                this.showSpinnerSave =false;
                this.$bvModal.hide('modalConfirmUpload');
            });

      }, 
      validationMsg: validationMessage(formMessages),
      getFileStudent(){
          let data = {
                id : this.id,
                flagEdited : this.flagEdited
          }
          baseInstanceAxios
          .get(`${this.apiURL}/Resources/PersonsAssignmentsEvaluations/GetPersonsAssignmentsEvaluationsByFile`,{
              params : data
          } )
          .then(response => {
              if(response.data.entity){
                let lstImages = ['png','jpg', 'jpeg']

                this.comment = response.data.entity.studentComments ? response.data.entity.studentComments : "";
                this.commnetInit = response.data.entity.studentComments ? response.data.entity.studentComments : "";
                this.fileRecords = response.data.entity.listPersonsAssignmentsEvaluationsFiles.map(element =>({
                  id: element.id,
                  name: element.name,// 'CU_ComprasEstudiantes_EA.jpg',
                  size: 41072,
                  type: element.urlFile ? lstImages.includes(element.urlFile.substr(element.urlFile.lastIndexOf('.') + 1)) ? 'image/jpeg' : element.urlFile.substr(element.urlFile.lastIndexOf('.') + 1):  'pdf',
                  url : response.data.entity.routeServer+element.urlFile//'https://english-advance-files-dev.s3.us-east-2.amazonaws.com/usuarios/alumnos/157/136/1/2021/5/CU_ComprasEstudiantes_EA.jpg'
       
                } ))
                
                this.fileRecordInit = this.fileRecords
              }
          });
      },
      uploadFiles: function () {
           
        this.$refs.vueFileAgent.upload(this.uploadUrl, this.uploadHeaders, this.fileRecordsForUpload);
        this.fileRecordsForUpload = [];
      },
      deleteUploadedFile: function (fileRecord) {
      
        this.$refs.vueFileAgent.deleteUpload(this.uploadUrl, this.uploadHeaders, fileRecord);
      },
      //contador ---------
      filesSelected: function (fileRecordsNewlySelected) {
        var validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error);
        this.fileRecordsForUpload = this.fileRecordsForUpload.concat(validFileRecords);
      },
      // antes de  eliminar ---------
      onBeforeDelete: function (fileRecord) {
        var i = this.fileRecordsForUpload.indexOf(fileRecord);
        if (i !== -1) {
          this.fileRecordsForUpload.splice(i, 1);
          var k = this.fileRecords.indexOf(fileRecord);
          if (k !== -1) this.fileRecords.splice(k, 1);
        } else {
          if (confirm(this.$t('evaluations.file-upload.message-confirm'))) {
            this.$refs.vueFileAgent.deleteFileRecord(fileRecord); 
          }
        }
      },
      // eliminar  -------
      fileDeleted: function (fileRecord) {
        if(fileRecord.id){
          this.listFilesDeleteId.push(fileRecord.id)
        }
       
        var i = this.fileRecordsForUpload.indexOf(fileRecord);
        if (i !== -1) {
          this.fileRecordsForUpload.splice(i, 1);
        } else {
          this.deleteUploadedFile(fileRecord);
        }
      },
      closeModalComfirmCancel(){
        this.$bvModal.hide('modalConfirmCancel');
                this.$router.push({name : 'teacher-class' , params : 
            { 
                course : this.$route.params.course,
                tabEvaluation: this.$route.params.flagEvaluation
            }})      
      },
      cancelButton(){        
         
        if(parseInt(this.id) != 0){
          if(this.commnetInit == this.comment && JSON.stringify(this.fileRecords) == JSON.stringify(this.fileRecordInit)){
           this.redireccionar();
          }else{
            this.$bvModal.show('modalConfirmCancel');            
          }          
        }
        else{
          this.redireccionar();
        }
            
      },
      redireccionar(){
        this.$router.push({name : 'teacher-class' , params : 
            { 
                course : this.$route.params.course,
                tabEvaluation: this.$route.params.flagEvaluation
            }})
      }
    }
  }
</script>